import useProfile from 'common/providers/useProfile'
import { useAuthSession } from 'hooks'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Avatars } from '../../../assets/avatars'
import { Avatar } from '../../../common/components/Avatar'
import { Burger, Checkmark } from '../../../icons'
import { MobileMenuHeader } from './MobileMenuHeader'
import { Menu } from './menuTypes'

interface MobileMenuProps {
  menu: Menu
  className?: string
}

const MobileMenu = ({ menu, className = '' }: MobileMenuProps) => {
  const [toggle, setToggle] = useState<boolean>(false)
  const { isAuthenticated, clearSession } = useAuthSession()
  const { profile } = useProfile()
  const navigate = useNavigate()

  return (
    <div className={`${className}`}>
      <button className='toggler' onClick={() => setToggle(!toggle)}>
        {toggle ? <Checkmark /> : <Burger />}
      </button>
      {toggle && (
        <div className={`mobile-nav ${!toggle && 'd-none'}`}>
          <div className='flex items-center justify-between py-3'>
            {isAuthenticated ? (
              <div className='flex items-center gap-5'>
                <Avatar
                  imgSource={Avatars._01}
                  fullName={`${profile?.first_name} ${profile?.last_name}`}
                />
                {`${profile?.first_name || ''} ${profile?.last_name || ''}`}
              </div>
            ) : (
              <img
                className='avatar'
                src={Avatars._Dummy}
                alt='placehodler avatar'
              />
            )}
            <button onClick={() => setToggle(!toggle)}>
              <Checkmark />
            </button>
          </div>
          <hr className='my-1' />
          <ul className=''>
            {isAuthenticated && (
              <>
                <div className='flex flex-column'>
                  <li>
                    <Link to='/profile' onClick={() => setToggle(false)}>
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link to=''>Appointments</Link>
                  </li>
                  <li>
                    <Link to=''>Documents Library</Link>
                  </li>
                  <li>
                    <Link to='/favourites'>Favourites</Link>
                  </li>
                  <li>
                    <Link to=''>Purchases</Link>
                  </li>
                </div>
                <hr className='my-2' />
              </>
            )}
            <MobileMenuHeader navigations={menu} />
            <hr className='my-1' />
            <li className=''>
              {isAuthenticated ? (
                <button
                  onClick={async () => {
                    setToggle(!toggle)
                    await clearSession()
                    navigate('/login')
                  }}
                  className='text-[#001A3D] font-semibold'
                >
                  Sign out
                </button>
              ) : (
                <button
                  onClick={() => {
                    setToggle(!toggle)
                    navigate('/login')
                  }}
                  className='text-[#001A3D] font-semibold'
                >
                  Sign in
                </button>
              )}
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default MobileMenu
